import React from "react";
// import OwlCarousel from 'react-owl-carousel2';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
import Meet01 from './images/santhosh.jpg'
import Meet02 from './images/prakash.jpg'
import Meet03 from './images/mini.jpg'
import Meet04 from './images/vikram.jpg'
import Meet06 from './images/pankaj.jpg'
import Meet07 from './images/umesh.jpg'
function AboutMeet() {

  return (
    <section className="section about-meet-session">
      <div className="section-desciption">
        <h2 className="gradient-one">Our Leadership Team</h2>
        {/* <p className="color-bright-2">
          Our comprehensive approach ensures meticulous.
        </p> */}
      </div>
      <div className="team-section">
        <div className="team-carousel member-data">
          <div className="team-member-data">
            <div className="team-member">
              <div className="member-image">
                <img src={Meet01} alt="Team Member 1" />
                <div className="social-icons">
                  <a href="https://www.linkedin.com/in/santosh-menon-163336" target="_blank" className="la la-linkedin"></a>
                  {/* <a href="javascript:void(0)" className="la la-facebook"></a>
                  <a href="javascript:void(0)" className="la la-instagram"></a> */}
                </div>
              </div>
              <div className="member-info">
                <h3>Santosh Menon</h3>
                <p>CEO</p>
              </div>

            </div>
            <div className="member-description">Santosh is a business leader with over 25 years of extensive experience in international business, across technology, energy, finance, and sports. He has the ability to navigate complex business landscapes, driving growth and innovation. A people-oriented leader, he believes in the power of collaboration and has a proven track record of building high-performing teams. He brings a strong commitment to integrating innovative technologies to enhance operational efficiency and value creation for customers. Santosh is a Graduate in Economics and Marketing from the UK. </div>
          </div>
          <div className="team-member-data">
            <div className="team-member">
              <div className="member-image">
                <img src={Meet06} alt="Team Member 1" />
                <div className="social-icons">
                  <a href="https://www.linkedin.com/in/pankaj-kumar-mishra-b473655" target="_blank" className="la la-linkedin"></a>
                  {/* <a href="javascript:void(0)" className="la la-facebook"></a>
                  <a href="javascript:void(0)" className="la la-instagram"></a> */}
                </div>
              </div>
              <div className="member-info">
                <h3>Pankaj Mishra</h3>
                <p>CSIO</p>
              </div>

            </div>
            <div className="member-description">Pankaj Kumar Mishra is the Chief Strategy & Information Officer of HTI. He has over 23 years of experience in IT Operations, Infrastructure, and IT Security, specializing in global transformation and practical solutions. With leadership roles at BNP Paribas, JP Morgan, T-Systems, and Wipro, his focus is on driving digital transformation, optimizing efficiency, and achieving cost savings. Pankaj's strategic leadership aligns business objectives, collaboration and leveraging data-driven insights. In addition, he is committed to mentoring talent and supporting environmental initiatives. </div>
          </div>

          <div className="team-member-data">
            <div className="team-member">
              <div className="member-image">
                <img src={Meet03} alt="Team Member 2" />
                <div className="social-icons">
                  <div className="social-icons">
                    <a href="https://www.linkedin.com/in/mini-balaraman-1040a33" target="_blank" className="la la-linkedin"></a>
                    {/* <a href="javascript:void(0)" className="la la-facebook"></a>
                    <a href="javascript:void(0)" className="la la-instagram"></a> */}
                  </div>
                </div>
              </div>
              <div className="member-info">
                <h3>Mini Balaraman</h3>
                <p>COO</p>
              </div>
            </div>
            <div className="member-description">Mini is the COO of HTI. She is responsible for key operational aspects of HTI and ensures
              that the overall HTI organization works optimally across all facets of the company. Mini
              returned to India after 14 years in the US, having worked at Blue Shield of California and
              Sun Microsystems (now Oracle) in various technical roles, from software development to
              Business Intelligence. She combines a unique blend of client-facing experience and strong technical knowledge. Mini holds a Master‘s degree in Computer Applications.</div>
          </div>
          <div className="team-member-data">
            <div className="team-member">
              <div className="member-image">
                <img src={Meet07} alt="Team Member 2" />
                <div className="social-icons">
                  <div className="social-icons">
                    <a href="https://www.linkedin.com/in/umesh-agroya-6017b624" target="_blank" className="la la-linkedin"></a>
                    {/* <a href="javascript:void(0)" className="la la-facebook"></a>
                    <a href="javascript:void(0)" className="la la-instagram"></a> */}
                  </div>
                </div>
              </div>
              <div className="member-info">
                <h3>Umesh Agroya </h3>
                <p>Head of IT Infrastructure</p>
              </div>
            </div>
            <div className="member-description">Umesh Agroya has joined HTI as Head of IT Infrastructure, bringing more than 26 years of experience in IT infrastructure, security engineering, and large-scale strategic project management across top financial institutions. He is renowned for pioneering datacenter builds, leading network migrations, implementing complex security architectures, and driving operational excellence in mission-critical environments. <br />

              Prior to joining HTI, Umesh was Head of IT Networks at the National Stock Exchange (NSE), Head of IT Infrastructure at Bank BNP Paribas, and SGM -  IT Infrastructure at the Bombay Stock Exchange (BSE). At HTI, Umesh leads the design, governance, and delivery of advanced digital platforms and resilient IT infrastructure.</div>
          </div>
          <div className="team-member-data">
            <div className="team-member">
              <div className="member-image">
                <img src={Meet02} alt="Team Member 2" />
                <div className="social-icons">
                  <a href="https://www.linkedin.com/in/prakashsathyapalan" target="_blank" className="la la-linkedin"></a>
                  {/* <a href="javascript:void(0)" className="la la-facebook"></a>
                  <a href="javascript:void(0)" className="la la-instagram"></a> */}
                </div>
              </div>
              <div className="member-info">
                <h3>Prakash Sathyaplan</h3>
                <p>CTO</p>
              </div>
            </div>
            <div className="member-description">Prakash is the CTO of HTI. He ensures that the HTI technology teams always deliver for
              our clients. He spent his career working in India and the US for leading tech companies in
              senior technology and managerial roles in companies like Stubhub(eBay), IBM (Cognos)
              and SAS Institute. He has over 20 plus years experience in software development, design,
              Data Science and Business Intelligence. Prakash holds a Master‘s degree in Computer science</div>
          </div>
          <div className="team-member-data">
            <div className="team-member">
              <div className="member-image">
                <img src={Meet04} alt="Team Member 1" />
                <div className="social-icons">
                  <a href="https://www.linkedin.com/in/viknair" target="_blank" className="la la-linkedin"></a>
                  {/* <a href="javascript:void(0)" className="la la-facebook"></a>
                  <a href="javascript:void(0)" className="la la-instagram"></a> */}
                </div>
              </div>
              <div className="member-info">
                <h3>Vikram Nair</h3>
                <p>Executive Director</p>
              </div>
            </div>
            <div className="member-description">Mr. Vikram the Executive Director of HTI and has over 20 years of experience working with
              technology companies in leadership, strategy and product design roles in North America
              and India. In addition, as an entrepreneur, he has helped found multiple start-ups. He
              believes in the ability of technology to empower people, bring them closer together and
              change the world for the better.</div>
          </div>
        </div>
      </div>

    </section>
  )
}
export default AboutMeet;